<template lang="html">
  <Form v-if="!$store.state.auth.resetPassword.sent"></Form>
  <Confirmation v-else></Confirmation>
</template>
<script>
  import Form from './_form.vue'
  import Confirmation from './_confirmation.vue'
  export default {
    components: {
      Form,
      Confirmation
    }
  }
</script>
<style lang="scss">
</style>